(function () {
    'use strict';

    angular
        .module('app.addAdvertiserToAgency')
        .factory('addAdvertiserToAgencyService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function addAdvertiserToAgency(params, loader) {
                    var url_addAdvertiserToAgency = $rootScope.apiUrl + 'company/addAdvertiserToAgency';
                    return handleRequest(url_addAdvertiserToAgency, 'POST', params, loader);
                }

                service.addAdvertiserToAgency = addAdvertiserToAgency;

                return service;
            }
        ]);
})();
